import React, { useState } from 'react';
import DateInput from './DateInput';

const STATUS_OPTIONS = [
  { value: 0,  label: 'חתום על הסכם ראשוני' },
  { value: 1,  label: 'חתום עם בעיית רישום על הסכם ראשוני' },
  { value: 2,  label: 'יש להשלים חתימה של הסכם ראשוני' },
  { value: 3,  label: 'דיור ציבורי' },
  { value: 4,  label: 'מסרב לשתף פעולה' },
  { value: 5,  label: 'בטיפול' },
  { value: 6,  label: 'לא נוצר קשר' },
  { value: 7,  label: 'חתום על הסכם סופי' },
  { value: 8,  label: 'חתום עם בעיית רישום' },
  { value: 9,  label: 'יש להשלים חתימה' },
  { value: 10, label: 'קיבל הסכם' },
  { value: 11, label: 'מגיע' },
  { value: 12, label: 'יש לתאם חתימה' },
  { value: 13, label: 'תואמה חתימה' },
  { value: 14, label: 'רוצים לחתום אך יש בעיה משפטית' },
  { value: 15, label: 'חתום על נון שופ - יהודה לוי' },
  { value: 16, label: 'חתום על הסכם סופי - יהודה לוי' },
  { value: 17, label: 'חתום על הסכם סופי עם הערת אזהרה - יהודה לוי' },
  { value: 18, label: 'לא יודע על מה חתום - יהודה לוי' },
  { value: 19, label: 'מגיע לכנס הצגת הסכם סקייליין' },
  { value: 20, label: 'גר בחוץ לארץ' },
];

export default function TenantForm({ initial = {}, onSubmit, onCancel, isEdit = false }) {
  const [form, setForm] = useState({
    id: initial.id || '',
    firstName: initial.firstName || '',
    lastName: initial.lastName || '',
    cellularPhone: initial.cellularPhone || '',
    homePhone: initial.homePhone || '',
    dob: initial.dob || '',
    email: initial.email || '',
    tenantType: initial.tenantType || '',
    tenantStatus: initial.tenantStatus || '',
    percentageOfHOldingInApartment: initial.percentageOfHOldingInApartment || '',
    isContactPerson: initial.isContactPerson || false,
    is_representative: initial.is_representative || false,
    hasPortalAccess: initial.hasPortalAccess || false,
    tenantNotes: initial.tenantNotes || '',
    tentantDateOfSignature: initial.tentantDateOfSignature || ''
  });

  function handleChange(e) {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setForm({ ...form, [e.target.name]: value });
  }

  const grid = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 20px' };
  const [errors, setErrors] = React.useState({});

  function validate() {
    const e = {};
    if (!form.id) e.id = true;
    if (!form.firstName) e.firstName = true;
    if (!form.lastName) e.lastName = true;
    if (!form.percentageOfHOldingInApartment && form.percentageOfHOldingInApartment !== 0) e.percentageOfHOldingInApartment = true;
    if (!form.tenantType) e.tenantType = true;
    if (form.tenantStatus === '' || form.tenantStatus === null || form.tenantStatus === undefined) e.tenantStatus = true;
    return e;
  }

  function handleSubmit(e) {
    e.preventDefault();
    const e2 = validate();
    if (Object.keys(e2).length) { setErrors(e2); return; }
    const isOwner = form.tenantType === 'בעלים' || form.tenantType === '0' || form.tenantType === 0;
    const pct = parseFloat(form.percentageOfHOldingInApartment);
    if (isOwner && (!form.percentageOfHOldingInApartment || isNaN(pct) || pct <= 0)) {
      alert('שים לב: סוג הדייר הוא "בעלים" אך אחוז ההחזקה בדירה הוא 0 או ריק. לא הגיוני שבעלים לא מחזיק אחוזים בדירה.');
      return;
    }
    onSubmit(form);
  }

  const req = <span style={{ color: '#dc2626', marginRight: 2 }}>*</span>;
  const errMsg = <span style={{ color: '#dc2626', fontSize: '0.75rem', fontWeight: 600, display: 'block', marginTop: 2 }}>נדרש למילוי</span>;
  function clr(name) { if (errors[name]) setErrors(prev => { const n = {...prev}; delete n[name]; return n; }); }

  return (
    <form onSubmit={handleSubmit}>
      <div style={grid}>
        <div className="form-group">
          <label>תעודת זהות {req}</label>
          <input name="id" value={form.id} onChange={e => { handleChange(e); clr('id'); }} style={errors.id ? { borderColor: '#dc2626' } : {}} />
          {errors.id && errMsg}
        </div>
        <div className="form-group">
          <label>תאריך לידה</label>
          <DateInput name="dob" value={form.dob} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>שם פרטי {req}</label>
          <input name="firstName" value={form.firstName} onChange={e => { handleChange(e); clr('firstName'); }} style={errors.firstName ? { borderColor: '#dc2626' } : {}} />
          {errors.firstName && errMsg}
        </div>
        <div className="form-group">
          <label>שם משפחה {req}</label>
          <input name="lastName" value={form.lastName} onChange={e => { handleChange(e); clr('lastName'); }} style={errors.lastName ? { borderColor: '#dc2626' } : {}} />
          {errors.lastName && errMsg}
        </div>
        <div className="form-group">
          <label>טלפון נייד</label>
          <input name="cellularPhone" value={form.cellularPhone} onChange={e => { handleChange(e); clr('cellularPhone'); }} placeholder="050-1234567 או לחו&quot;ל: +14134188499" style={errors.cellularPhone ? { borderColor: '#dc2626' } : {}} />
          <div style={{ fontSize: '0.72rem', color: '#6b7280', marginTop: 2 }}>לדייר בחו״ל: הזינו + וקידומת מדינה (למשל +1 לארה״ב), ללא אפס מוביל</div>
        </div>
        <div className="form-group">
          <label>טלפון בית</label>
          <input name="homePhone" value={form.homePhone} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>אימייל</label>
          <input name="email" value={form.email} onChange={handleChange} type="email" />
        </div>
        <div className="form-group">
          <label>% החזקה בדירה {req}</label>
          <input name="percentageOfHOldingInApartment" value={form.percentageOfHOldingInApartment} onChange={e => { handleChange(e); clr('percentageOfHOldingInApartment'); }} type="number" min="0" max="1" step="any" style={errors.percentageOfHOldingInApartment ? { borderColor: '#dc2626' } : {}} />
          {errors.percentageOfHOldingInApartment && errMsg}
        </div>
        <div className="form-group">
          <label>סוג דייר {req}</label>
          <select name="tenantType" value={form.tenantType} onChange={e => { handleChange(e); clr('tenantType'); }} style={errors.tenantType ? { borderColor: '#dc2626' } : {}}>
            <option value="">-- בחר --</option>
            <option value="בעלים">בעלים</option>
            <option value="1">משכירים</option>
            <option value="2">מדינת ישראל</option>
            <option value="3">איש קשר</option>
            <option value="4">אפוטרופוס</option>
            <option value="חלקה מיוחדת">חלקה מיוחדת</option>
            <option value="חנות/משרד">חנות/משרד</option>
          </select>
          {errors.tenantType && errMsg}
        </div>
        <div className="form-group">
          <label>סטטוס {req}</label>
          <select name="tenantStatus" value={form.tenantStatus} onChange={e => { handleChange(e); clr('tenantStatus'); }} style={errors.tenantStatus ? { borderColor: '#dc2626' } : {}}>
            <option value="">-- בחר סטטוס --</option>
            {STATUS_OPTIONS.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
          {errors.tenantStatus && errMsg}
        </div>
        <div className="form-group">
          <label>תאריך חתימה</label>
          <DateInput name="tentantDateOfSignature" value={form.tentantDateOfSignature} onChange={handleChange} />
        </div>
      </div>

      <div className="form-group">
        <label>הערות</label>
        <textarea name="tenantNotes" value={form.tenantNotes} onChange={handleChange} rows={2} />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <input type="checkbox" name="isContactPerson" checked={!!form.isContactPerson} onChange={handleChange} id="isContactPerson" />
          <label htmlFor="isContactPerson" style={{ marginBottom: 0, fontWeight: 500, fontSize: '0.9rem', textTransform: 'none' }}>איש קשר</label>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <input type="checkbox" name="is_representative" checked={!!form.is_representative} onChange={handleChange} id="is_representative" />
          <label htmlFor="is_representative" style={{ marginBottom: 0, fontWeight: 500, fontSize: '0.9rem', textTransform: 'none' }}>נציג</label>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <input type="checkbox" name="hasPortalAccess" checked={!!form.hasPortalAccess} onChange={handleChange} id="hasPortalAccess" />
          <label htmlFor="hasPortalAccess" style={{ marginBottom: 0, fontWeight: 500, fontSize: '0.9rem', textTransform: 'none' }}>גישה למערכת</label>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <button type="submit" className="btn btn-primary">שמור</button>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>ביטול</button>
      </div>
    </form>
  );
}
